import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const REGISTRATION_FAIL = 'REGISTRATION_FAIL';

export const useOnRegistrationFail = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: any) => {
        const event = new CustomEvent(REGISTRATION_FAIL, { detail: [detail] });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('registration:error', handleEvent);

        return () => publicEventsAPIService.off('registration:error', handleEvent);
    }, [handleEvent]);
};
